"use client";

interface StreamingIndicatorProps {
  providerName: string;
  color: string;
}

export default function StreamingIndicator({
  color,
}: StreamingIndicatorProps) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        padding: "8px 0",
        color: "var(--text-secondary)",
        fontSize: "14px",
      }}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        style={{ animation: "spin 1.2s linear infinite", flexShrink: 0 }}
      >
        <circle cx="8" cy="8" r="6.5" stroke={color} strokeWidth="1.5" opacity="0.25" />
        <path
          d="M14.5 8a6.5 6.5 0 00-6.5-6.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
      <span>Waiting for response...</span>
      <style jsx>{`
        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
}
